import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import FocusBar from "@/pages/home/components/FocusBar";
import FeatureWall from "@/pages/home/components/FeatureWall";
import CompareSection from "@/pages/home/components/CompareSection";
import ReplySection from "@/pages/home/components/ReplySection";
import CommentSection from "@/pages/home/components/CommentSection";
import TimelineSection from "@/pages/home/components/TimelineSection";
import TopicSection from "@/pages/home/components/TopicSection";
import DownloadSection from "@/pages/home/components/DownloadSection";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <Navbar />
      <main className="w-full flex-1">
        <Hero />
        <FocusBar />
        <FeatureWall />
        <CompareSection />
        <ReplySection />
        <CommentSection />
        <TimelineSection />
        <TopicSection />
        <DownloadSection />
      </main>
      <Footer />
    </div>
  );
}